import React from 'react';
import { motion } from 'framer-motion';

const industryList = [
  {
    name: 'Water & Wastewater',
    icon: '💧',
    color: 'text-blue-600',
    bg: 'bg-blue-50',
  },
  {
    name: 'Chemicals',
    icon: '⚗️',
    color: 'text-green-600',
    bg: 'bg-green-50',
  },
  {
    name: 'Biogas & Energy',
    icon: '⚡',
    color: 'text-yellow-600',
    bg: 'bg-yellow-50',
  },
  {
    name: 'Food & Edible Oils',
    icon: '🌽',
    color: 'text-orange-600',
    bg: 'bg-orange-50',
  },
  {
    name: 'Cosmetics & Pharma',
    icon: '💄',
    color: 'text-pink-600',
    bg: 'bg-pink-50',
  },
];

const Industries = () => {
  return (
    <section id="industries" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          s className="text-center mb-16"
        >
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Industries We Serve
          </h2>
          <div className="w-24 h-1 bg-blue-600 mx-auto"></div>
        </motion.div>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
          {industryList.map((industry, index) => (
            <motion.div
              key={industry.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ y: -5, scale: 1.05 }}
              className={`p-8 rounded-xl shadow-lg hover:shadow-xl transition-all ${industry.bg} border-t-4 ${industry.color.replace('text', 'border')}`}
            >
              <div className={`text-5xl mb-5 text-center ${industry.color}`}>
                {industry.icon}
              </div>
              <h3 className="text-lg font-semibold text-gray-900 text-center">
                {industry.name}
              </h3>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Industries;